export const ROLE_LEVEL_LABELS = {
  1: "系統管理者",
  2: "品牌最高管理者",
  3: "品牌管理者",
  4: "區域管理者",
  5: "操作人員",
};

export const ROLE_LEVEL_RANKS = {
  1: 1,
  2: 2,
  3: 3,
  4: 4,
  5: 5,
};

const normalizeRoleLevel = (value) => {
  const numeric = Number(value);
  return Number.isInteger(numeric) && numeric > 0 ? numeric : null;
};

const MANAGEMENT_LEVELS = [1, 2, 3];
const ROUTE_MANAGER_LEVELS = [1, 2, 3, 4];

const FEATURE_ROLE_LEVELS = {
  marketingdataanalysis: [1, 2, 3],
  products: [1, 2],
  warehouses: [1, 2, 3, 4],
  warehousesRealtime: [1, 2, 3, 4, 5],
  taskreview: [1, 2, 3, 4],
  "abnormal-orders": [1, 2, 3],
  transactions: [1, 2, 3, 4],
  "transactions-new": [1, 2, 3, 4],
  invoices: [1, 2, 3],
  "billing-reconcile": [1, 2, 3],
  manufacturer: [1, 2, 3, 4, 5],
  venues: [1, 2, 3, 4, 5],
  machinebootstrapsetup: [1, 2, 3],
  deviceinfos: [1, 2, 3, 4, 5],
  agentmanagements: [1, 2, 3, 4],
  membershipmanagement: [1, 2, 3],
  usermanagement: [1, 2, 3, 4],
  permissionmanagement: [1, 2, 3, 4, 5],
  couponmanagement: [1, 2, 3],
  "reset-password": [1, 2, 3, 4, 5],
  "sign-out": [1, 2, 3, 4, 5],
};

const FEATURE_ROLE_PARAM_OVERRIDES = {
  transactions: {
    "bkadmin@erp.astrophant.online": 4,
  },
};

export const ALL_ROLE_LEVELS = Object.keys(ROLE_LEVEL_LABELS).map(Number);

export { normalizeRoleLevel };

export const getRoleLabelByLevel = (roleLevel) => {
  const numeric = normalizeRoleLevel(roleLevel);
  return numeric ? ROLE_LEVEL_LABELS[numeric] || "" : "";
};

export const getAllowedRoleLevelsForFeature = (featureKey) => FEATURE_ROLE_LEVELS[featureKey] || [];

export const canAccessFeature = (featureKey, roleLevel) => {
  const numeric = normalizeRoleLevel(roleLevel);
  return Boolean(numeric && getAllowedRoleLevelsForFeature(featureKey).includes(numeric));
};

export const isManagementRoleLevel = (roleLevel) =>
  MANAGEMENT_LEVELS.includes(normalizeRoleLevel(roleLevel));

export const canUseManagerRouteSet = (roleLevel) =>
  ROUTE_MANAGER_LEVELS.includes(normalizeRoleLevel(roleLevel));

export const isOpsRoleLevel = (roleLevel) => normalizeRoleLevel(roleLevel) === 5;

export const getRoleParamForFeature = (featureKey, roleLevel, email) => {
  const normalizedEmail = String(email || "").toLowerCase();
  const overriddenLevel = FEATURE_ROLE_PARAM_OVERRIDES[featureKey]?.[normalizedEmail];
  const resolvedLevel = normalizeRoleLevel(overriddenLevel ?? roleLevel);

  // Legacy iframe/Appsmith APIs still expect textual role params.
  switch (resolvedLevel) {
    case 1:
    case 2:
    case 3:
      return "BK";
    case 4:
      return "CM";
    case 5:
      return "OP";
    default:
      return "BK";
  }
};
